import { WorkpackService } from 'client/services';

const loader = async ({ params }) => {
    const workpackRequest = await WorkpackService.getWorkpackRequest(params.workpackReqId);
    return { workpackRequest };
};

export default loader;
